import {Button, Card} from "react-bootstrap";
import React, {useState} from "react";
import {ConfirmDeleteDialog} from "./ConfirmDeleteDialog";
import AdhocImageGallary from "../AdhocImageGallary";

const issueLabelMap = {
    'fix': 'Property Require Maintenance',
    'clean': 'Property Require Deep Clean',
    'key': 'Property Key Missing'
};

export const PropertyIssueView = (props) => {
    const {editMode, issue, actionReopenPropertyIssue, actionDeletePropertyIssue, actionResolvePropertyIssue} = props;
    const [isDeleteDialogVisible, setDeleteDialogVisible] = useState(false);
    const [isReopenDialogVisible, setReopenDialogVisible] = useState(false);

    const issueLabel = issueLabelMap[issue.category];

    const localDate = (input_date) => {
        if (input_date) {
            return new Date(input_date).toLocaleDateString();
        }
        return "";
    };

    const borderColor = () => {
        return issue.status === 'open' ? 'red' : 'green';
    };

    const handleDelete = () => {
        actionDeletePropertyIssue(issue.id);
        setDeleteDialogVisible(false);
    };

    const handleReopen = () => {
        let updatedFormData = {
            ...issue,
            action: 'reopen'
        };
        actionReopenPropertyIssue(updatedFormData);
        setReopenDialogVisible(false);
    };

    const handleResolve = () => {
        let updatedFormData = {
            ...issue,
            action: 'resolve'
        };
        actionResolvePropertyIssue(updatedFormData);
    };

    return (
        <>
            <Card style={{borderColor: borderColor(), ...styles.card}}>
                <Card.Body>
                    <div style={styles.row}>
                        <span style={styles.titleText}>{issueLabel}</span>
                        <ConfirmDeleteDialog
                            visible={isDeleteDialogVisible}
                            onConfirm={handleDelete}
                            onCancel={() => setDeleteDialogVisible(false)}
                            message="Are you sure you want to delete this item?"
                        />
                        <ConfirmDeleteDialog
                            visible={isReopenDialogVisible}
                            onConfirm={handleReopen}
                            onCancel={() => setReopenDialogVisible(false)}
                            message="Are you sure you want to Re-Open this issue?"
                        />
                        <span style={{...styles.statusText, color: borderColor()}}>{issue.status}</span>
                    </div>
                    <div style={styles.detailContainer}>
                        <span style={styles.labelTitle}>Description: </span><span>{issue.description}</span>
                    </div>
                    <div style={styles.detailContainer}>
                        <span style={styles.labelTitle}>Reported Date:</span><span> {localDate(issue.date)}</span>
                    </div>
                    <div style={styles.detailContainer}>
                        <span style={styles.labelTitle}>Issue Photos:</span>
                    </div>
                    <AdhocImageGallary images={issue.images} isReadOnly={true}
                                       setImages={() => {
                                       }}/>
                    {issue.status === 'closed' && (
                        <>
                            <div style={styles.detailContainer}>
                                <span style={styles.resolutionTitle}>Resolution:</span>
                            </div>
                            <hr/>
                            <div style={styles.detailContainer}>
                                <span
                                    style={styles.labelTitle}>Date: </span><span>{localDate(issue.resolved_date)}</span>
                            </div>
                            <div style={styles.detailContainer}>
                                <span style={styles.labelTitle}>Description: </span>
                                <span>{issue.resolve_description ?? 'No Description'}</span>
                            </div>
                            <div style={styles.detailContainer}>
                                <span style={styles.labelTitle}>Resolved By: </span>
                                <span>{issue.resolved_by_name}</span>
                            </div>
                            <div style={styles.detailContainer}>
                                <span style={styles.labelTitle}>Photos:</span>
                            </div>
                            <AdhocImageGallary images={issue.resolve_images} isReadOnly={true}
                                               setImages={() => {
                                               }}/>
                        </>
                    )}
                </Card.Body>

                <Card.Footer>
                    <Button style={{marginRight: "10px"}} variant="outline-primary"
                            onClick={() => setDeleteDialogVisible(true)}>Delete</Button>
                    {issue.status === 'closed' ? (
                        <Button variant="outline-primary" onClick={() => setReopenDialogVisible(true)}>Re-open</Button>
                    ) : (
                        <Button variant="primary" onClick={() => handleResolve()}>Resolve</Button>
                    )}
                </Card.Footer>
            </Card>
        </>
    );
};

const styles = {
    card: {
        borderStyle: "solid",
        borderWidth: 1,
        margin: 5,
    },
    row: {
        display: "flex",
        justifyContent: "space-between",
    },
    titleText: {
        fontSize: 18,
        fontWeight: 800,
    },
    statusText: {
        textTransform: "capitalize",
        fontSize: 18,
        marginLeft: "auto",
        fontWeight: 800,
    },
    detailContainer: {
        marginTop: 15,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
    },
    labelTitle: {
        fontWeight: 600,
        fontSize: 14,
    },
    resolutionTitle: {
        fontWeight: 800,
        fontSize: 16,
    },
};
